import React from 'react';
import { MainLayout } from '@esg/ui';
import { ManagementSidebar } from './Sidebars';
import { ManagementContent } from './Contents';
import './Layout.scss';


export const ManagementLayout: React.FC = () => {


    return (
        <MainLayout
            sidebar={<ManagementSidebar />}
            content={<ManagementContent />}
            sidebarClassName={`management-sidebar `}
            contentClassName={`management-content `}
        />
    );
};